<template>
  <layout :title="pageTitle">
    <form @submit.prevent="submit">
      <section class="section">
        <div class="columns">
          <div class="column is-12">
            <div class="box">
              <a id="overview"></a>
              <h3>Overview</h3>
              <hr style="margin-top: 15px" />
              <div class="columns">
                <div class="column">
                  <b-field
                    label="Question Set Name"
                    :type="{ 'is-danger': errors?.name }"
                    :message="errors?.name"
                  >
                    <b-input v-model="questionSetForm.name"></b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <button
              v-on:submit.prevent
              type="submit"
              class="button is-primary"
              :disabled="isDisabled"
            >
              Next
            </button>
          </div>
        </div>
      </section>
    </form>
  </layout>
</template>

<script>
import Layout from '../Layout';

export default {
  components: {
    Layout,
  },
  props: {
    questionSet: { type: Object },
    successDrivers: { type: Array },
    errors: { type: Object },
  },
  data() {
    return {
      pageTitle: 'Add Question Set',
      questionSetForm: this.questionSet,
      isFullPage: true,
      isLoading: false,
    };
  },
  methods: {
    submit() {
      this.$inertia.post(route('question-sets.store'), this.questionSetForm);
    },
  },
  computed: {
    isDisabled: function () {
      return this.questionSetForm.name == '';
    },
  },
};
</script>
